/**
 * Responsive spacing constants for consistent clamp values across components.
 * These values provide fluid scaling between mobile and desktop breakpoints.
 *
 * The 12vw preferred value was chosen because:
 * - At 320px viewport: 12vw = 38.4px (triggers min clamp)
 * - At 768px viewport: 12vw = 92.2px (fluid middle range)
 * - At 1280px viewport: 12vw = 153.6px (triggers max clamp)
 * This creates a smooth progression that feels proportional across device sizes.
 */

// Section vertical padding: scales from mobile (64-80px) to desktop (96-177px)
export const SECTION_PADDING_Y = {
  XSMALL: "clamp(8px, 2vw, 20px)", // For very tight vertical spacing
  SMALL: "clamp(64px, 12vw, 96px)", // For compact sections
  MEDIUM: "clamp(72px, 12vw, 129px)", // For standard sections
  LARGE: "clamp(80px, 12vw, 161px)", // For prominent sections
  XLARGE: "clamp(96px, 12vw, 177px)", // For extra prominent sections
  HERO: "clamp(64px, 12vw, 110px)", // For hero sections
} as const;

// Section horizontal padding: responsive clamp (20px → 48px) plus a fixed compact value
export const SECTION_PADDING_X = {
  RESPONSIVE: "clamp(20px, 5vw, 48px)",
  COMPACT: "20px",
} as const;

// Section gaps: scales from mobile (40-64px) to desktop (64-96px)
export const SECTION_GAP = {
  SMALL: "clamp(40px, 8vw, 64px)",
  MEDIUM: "64px",
  LARGE: "clamp(64px, 12vw, 96px)",
} as const;

// Sticky positioning: uses dvh for iOS Safari compatibility
export const STICKY_TOP = {
  // 20vh equivalent using dynamic viewport height for iOS
  STICKY_IMAGE: "20dvh",
} as const;
